import { required, numeric } from 'vuelidate/lib/validators';

export const investmentRequestAmount = {
    value: {
        required,
        numeric,
    },
};
